import { env } from 'env.client'

export const META_CRM_SCRIPT = `
  async function loadScript(src) {
    return new Promise((resolve, reject) => {
      var fjs = document.getElementsByTagName('script')[0];
      if (document.getElementById('widget-dom-id')) return;
      const script = document.createElement('script');
      script.crossOrigin="anonymous";
      script.id = 'widget-dom-id';
      script.src = src;
      script.integrity = "sha384-4MqNl/6xuOxT0xhGNaKAd1PuglbLDMyfBuspqNJB2kiXWwB1VYt7tjqXOrGQzB6N";
      script.onload = () => resolve(script);
      script.onerror = () => reject(new Error('Script load error for ' + src));
      fjs.parentNode.insertBefore(script, fjs);
    });
  }
  (async function () {
    try {
      await loadScript('https://widget.metacrm.inc/static/js/widget-3-2-0.js');
      MetaCRMWidget.init({
        apiKey: '${env.NEXT_PUBLIC_META_CRM_API_KEY}',
        autoOpenNewNotification: true,
      });
    } catch (error) {
      console.error('Failed to load widget.js', error);
    }
  })();`
